import { Alert, AlertDescription } from "@repo/ui/components/ui/alert";
import { ShieldAlert } from "lucide-react";

export function ReadOnlyAlert({ message }: { message?: string }) {
  return (
    <Alert variant="destructive">
      <ShieldAlert className="h-4 w-4" />
      <AlertDescription>
        {message ?? "You do not have permission to edit. Contact an admin for access."}
      </AlertDescription>
    </Alert>
  );
}
